import { useQuery } from "@tanstack/react-query";

import { modelVersionQuery } from "#modules/models/infra/modelVersion.query";

export const useMyModelVersion = ({ enabled }: { enabled: boolean }) => {
  const { data, ...rest } = useQuery({ ...modelVersionQuery(), enabled });

  return { modelVersion: data?.version, ...rest };
};
